
import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import {
  DropdownMenuSeparator,
  DropdownMenuLabel,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

interface AdminMenuItemsProps {
  isAdmin: boolean;
}

const AdminMenuItems = ({ isAdmin }: AdminMenuItemsProps) => {
  const navigate = useNavigate();
  
  if (!isAdmin) return null;
  
  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="font-medium text-xs text-amber-600 dark:text-amber-400">
        Admin Tools
      </DropdownMenuLabel>
      <DropdownMenuItem onClick={() => navigate("/admin/dashboard")} className="cursor-pointer">
        <ShieldCheck className="mr-2 h-4 w-4" />
        <span>Admin Dashboard</span>
      </DropdownMenuItem>
    </>
  );
};

export default AdminMenuItems;
